import {
  TOGGLE_NOTEBOOK_COLLAPSE,
  SET_NOTEBOOK_SECTION,
  SET_NEW_CURRENT_PROTOCOL_SLIDE,
} from '../Redux.constants';

export const toggleNotebookCollapse = (toggleValue) => ({
  type: TOGGLE_NOTEBOOK_COLLAPSE,
  payload: toggleValue,
});

export const setNoteBookSection = (section) => ({
  type: SET_NOTEBOOK_SECTION,
  payload: {section},
});

export const setNextDesignSlideAsCurrent = (currentSlideType) => ({
  type: SET_NEW_CURRENT_PROTOCOL_SLIDE,
  payload: {currentSlideType},
});
